/** Presentation only: no local stock arithmetic, unit conversion or traffic-light rules. */
export function lineStock(line) {
  const stock = line?.stock;
  if (line?.stockPending && (!stock || stock.status !== "ok" || stock.reason === "stale" || stock.item_code != null && String(stock.item_code) !== String(line.code ?? ""))) return { status: "checking" };
  if (!stock || typeof stock !== "object" || Array.isArray(stock)) return { status: "not_queried" };
  if (stock.item_code != null && String(stock.item_code) !== String(line.code ?? "")) return { status: "not_queried" };
  if ((stock.schema_version != null && stock.schema_version !== "atlas.stock/1") || !["ok", "unavailable", "not_applicable"].includes(stock.status)) {
    return { status: "unavailable" };
  }
  if (stock.reason === "stale") return { ...stock, status: "unavailable", indicator: null };
  return { ...stock, ...(line?.stockPending ? { refreshing: true } : {}), indicator: stock.status === "ok" && ["green", "amber", "red"].includes(stock.indicator) ? stock.indicator : null };
}

export function stockNumber(value, locale = "es-ES") {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 20 }).format(value).replace(/^-/, "−");
}

export function stockDate(value, locale = "es-ES") {
  if (typeof value !== "string" || !value.trim()) return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  return new Intl.DateTimeFormat(locale, {
    timeZone: "Europe/Madrid", dateStyle: "short", timeStyle: "short",
  }).format(date);
}

/**
 * Minimum purchase quantity published by Atlas from the ERP stock (qMin), as
 * given: informative only, never compared with the requested quantity and
 * without a unit (the ERP does not certify it). A minimum of 1 says nothing.
 */
export function minimumPurchase(stock) {
  const value = stock?.minimum_purchase_quantity;
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 1) return null;
  const packaging = typeof stock.packaging === "string" && stock.packaging.trim() ? stock.packaging.trim() : null;
  return { value, packaging };
}

/**
 * El aviso de cantidad mínima solo tiene sentido si lo pedido queda por debajo: con la cantidad
 * igual o superior a la mínima no se muestra. Sin cantidad conocida se sigue avisando.
 */
export function belowMinimumPurchase(minimum, quantityMilli) {
  if (!minimum) return false;
  if (!Number.isSafeInteger(quantityMilli) || quantityMilli <= 0) return true;
  return quantityMilli < Math.round(minimum.value * 1000);
}
